export const KrFlag = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_27157_109143)">
        <mask
          id="mask0_27157_109143"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <circle
            cx="10"
            cy="10"
            r="10"
            fill="#C4C4C4"
          />
        </mask>
        <g mask="url(#mask0_27157_109143)"></g>
        <g clipPath="url(#clip1_27157_109143)">
          <path
            d="M0 0V20H20V0H0Z"
            fill="white"
          />
          <path
            d="M5.14638 4.80005L3.29738 7.57355L5.14638 4.80005ZM3.99075 8.0358L5.83975 5.2623L3.99075 8.0358ZM6.53313 5.72455L4.68413 8.49805L6.53313 5.72455ZM13.4669 14.3532L14.3143 13.082L13.4669 14.3532ZM14.4684 12.8509L15.3159 11.5797L14.4684 12.8509ZM16.0093 12.042L15.1618 13.3132L16.0093 12.042ZM15.0077 13.5443L14.1603 14.8155L15.0077 13.5443ZM14.8536 15.2777L15.7011 14.0065L14.8536 15.2777ZM15.8552 13.7754L16.7026 12.5042L15.8552 13.7754Z"
            fill="black"
          />
          <path
            d="M5.14638 4.80005L3.29738 7.57355M3.99075 8.0358L5.83975 5.2623M6.53313 5.72455L4.68413 8.49805M13.4669 14.3532L14.3143 13.082M14.4684 12.8509L15.3159 11.5797M16.0093 12.042L15.1618 13.3132M15.0077 13.5443L14.1603 14.8155M14.8536 15.2777L15.7011 14.0065M15.8552 13.7754L16.7026 12.5042"
            stroke="black"
            strokeWidth="0.555556"
          />
          <path
            d="M3.29738 12.5042L5.14638 15.2777L3.29738 12.5042ZM5.83975 14.8154L4.9923 13.5442L5.83975 14.8154ZM4.83821 13.3131L3.99075 12.0419L4.83821 13.3131ZM4.68413 11.5797L6.53313 14.3532L4.68413 11.5797ZM15.3159 8.49798L14.4684 7.22679L15.3159 8.49798ZM14.3143 6.99567L13.4669 5.72448L14.3143 6.99567ZM14.1603 5.26223L16.0093 8.03573L14.1603 5.26223ZM16.7026 7.57348L15.8552 6.30229L16.7026 7.57348ZM15.7011 6.07117L14.8536 4.79998L15.7011 6.07117Z"
            fill="black"
          />
          <path
            d="M3.29738 12.5042L5.14638 15.2777M5.83975 14.8154L4.9923 13.5442M4.83821 13.3131L3.99075 12.0419M4.68413 11.5797L6.53313 14.3532M15.3159 8.49798L14.4684 7.22679M14.3143 6.99567L13.4669 5.72448M14.1603 5.26223L16.0093 8.03573M16.7026 7.57348L15.8552 6.30229M15.7011 6.07117L14.8536 4.79998"
            stroke="black"
            strokeWidth="0.555556"
          />
          <path
            d="M11.3868 10.9469C11.019 11.4986 10.4471 11.8816 9.79693 12.0116C9.14677 12.1416 8.47157 12.0081 7.91989 11.6403C7.36821 11.2725 6.98522 10.7006 6.85519 10.0504C6.72516 9.40028 6.85873 8.72509 7.22652 8.1734C7.7169 7.43782 8.47941 6.92718 9.3463 6.7538C10.2132 6.58042 11.1134 6.75852 11.849 7.2489C12.5846 7.73929 13.0952 8.5018 13.2686 9.36868C13.442 10.2356 13.2639 11.1358 12.7735 11.8714"
            fill="#CD2E3A"
          />
          <path
            d="M10 10.0224C10.2452 9.65458 10.6264 9.39926 11.0599 9.31257C11.4933 9.22588 11.9435 9.31493 12.3113 9.56012C12.679 9.80531 12.9344 10.1866 13.0211 10.62C13.1077 11.0535 13.0187 11.5036 12.7735 11.8714C12.2831 12.607 11.5206 13.1176 10.6537 13.291C9.78683 13.4644 8.88658 13.2863 8.151 12.7959C7.41542 12.3055 6.90478 11.543 6.7314 10.6761C6.55802 9.80921 6.73612 8.90895 7.2265 8.17337C6.98131 8.54116 6.89226 8.99129 6.97895 9.42473C7.06564 9.85818 7.32096 10.2394 7.68875 10.4846C8.05654 10.7298 8.50667 10.8189 8.94011 10.7322C9.37355 10.6455 9.75481 10.3902 10 10.0224Z"
            fill="#0047A0"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_27157_109143">
          <rect
            width="20"
            height="20"
            rx="10"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_27157_109143">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
